import data_warehouse         from '../assets/img/ecerts-logo/data_warehouse.png';
import engineering_practices  from '../assets/img/ecerts-logo/engineering_practices.png';
import intro_to_data_sci      from '../assets/img/ecerts-logo/intro_to_data_sci.png';
import essential_tools        from '../assets/img/ecerts-logo/essential_tools_for_app_dev.png';
import greedy_algorithms      from '../assets/img/ecerts-logo/greedy_algorithms.png';
import intro_to_ai            from '../assets/img/ecerts-logo/intro_to_ai_cert.png';
import sdp_methodologies      from '../assets/img/ecerts-logo/software_development_process_and_methodologies.png';
import version_control_git    from '../assets/img/ecerts-logo/version_control_git.png';

/**
 * E-Certificate data — used by the ECertificates section.
 * Each entry corresponds to one sticky scroll frame.
 */
export const CERTIFICATES = [
  {
    id: 'data-warehouse',
    image: data_warehouse,
    title: 'Data Warehouse',
    issuer: 'Coursera',
  },
  {
    id: 'engineering-practices',
    image: engineering_practices,
    title: 'Engineering Practices',
    issuer: 'Coursera',
  },
  {
    id: 'intro-data-science',
    image: intro_to_data_sci,
    title: 'Introduction to Data Science',
    issuer: 'Coursera',
  },
  {
    id: 'essential-tools',
    image: essential_tools,
    title: 'Essential Tools for App Development',
    issuer: 'Coursera',
  },
  {
    id: 'greedy-algorithms',
    image: greedy_algorithms,
    title: 'Greedy Algorithms',
    issuer: 'Coursera',
  },
  {
    id: 'intro-ai',
    image: intro_to_ai,
    title: 'Introduction to Artificial Intelligence',
    issuer: 'Coursera',
  },
  {
    id: 'sdp-methodologies',
    image: sdp_methodologies,
    title: 'Software Development Process and Methodologies',
    issuer: 'Coursera',
  },
  {
    id: 'version-control-git',
    image: version_control_git,
    title: 'Version Control with Git',
    issuer: 'Coursera',
  },
];
